import { webrequest } from '../../../httpsnippet-lite/targets/powershell/webrequest/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * powershell/webrequest
 */
export const powershellWebrequest = {
    target: 'powershell',
    client: 'webrequest',
    title: 'Invoke-WebRequest',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(webrequest, request);
    },
};
